/**
 * FERP Portal - Unified Primitive Page
 *
 * Entry point for the comprehensive 25-primitive management interface.
 * Wraps the UnifiedPrimitiveForm component for use as a route.
 *
 * Route: /architect/unified-primitives
 */

import { UnifiedPrimitiveForm } from '@/components/UnifiedPrimitiveForm';

export function UnifiedPrimitivePage() {
  return <UnifiedPrimitiveForm />;
}

export default UnifiedPrimitivePage;
